import React from 'react'
import Sidebar from "../components/Sidebar"
import VerifyTable from '../components/VerifyTable';
import { Spinner } from "react-bootstrap"
import { useState, useEffect } from "react";

import "../css/verifyusers.css"

export default function VerifyUsers() {

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false)
    }, 1400);
  }, [])


  return (
    <>
      {
        loading ?

          <div className="loader-screen">
            <Spinner className="loader-icon" animation="border" variant="primary" />
          </div>

          :
          
          <div className="home">
            <Sidebar />
            <div className="homeContainer">
              <div className="listContainer">

                <VerifyTable />

              </div>
            </div>
          </div>
      }

    </>
  )
}
